import { createFileRoute } from "@tanstack/react-router";

import { Link } from "@/components/base/link";
import { title } from "@/components/base/primitives";
import { AccountRecoveryForm } from "@/components/users/account-recovery-form";
import { DefaultLayout } from "@/layouts/default";

export const Route = createFileRoute("/account/recover")({
  head: () => ({
    meta: [{ title: "Account Recovery" }],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DefaultLayout>
      <div className="mx-auto flex max-w-xl flex-col space-y-6 text-center">
        <h1 className={title({ size: "lg" })}>Account Recovery</h1>

        <p className="mx-auto max-w-md">
          If you had an account on our previous system but don't remember which
          email you used, enter your name and date of birth below to find your
          account.
        </p>
      </div>

      <AccountRecoveryForm className="mx-auto w-full max-w-sm rounded-lg bg-white p-8" />

      <p className="mt-4 text-center text-gray-600">
        Know your email?{" "}
        <Link to="/account/forgot-password/email">Reset your password</Link>
      </p>
    </DefaultLayout>
  );
}
